module.exports = __webpack_public_path__ + "img/schysst_elhandel@2x.f5c18eb8.jpg";